import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import propsPerfil from "../../interfaces/propsPerfil"
import { descriptografarDado } from "../../helpers"

const useUsuarioPerfil = () => {

    const [perfil, setPerfil] = useState<string>('')
    const navigate = useNavigate()

    useEffect(() => {

        const perfilLogado = () => {

            try {

                const perfilUsuario = localStorage.getItem('perfilGesttor')
                const cookie = document.cookie.indexOf('authGesttor')

                if (cookie === null || cookie === undefined || perfilUsuario === null || perfilUsuario === undefined) {
                    return window.close()
                }
                const perfilDescript = descriptografarDado(perfilUsuario)

                setPerfil(perfilDescript)

            } catch (error: any) {
                return alert(error)
            }
        }

        perfilLogado()

    }, [setPerfil, navigate])

    return perfil
}

const Perfil = (props: propsPerfil) => {

    const usuarioPerfil = useUsuarioPerfil()

    if (props.perfil.some(perfil => usuarioPerfil.includes(perfil))) {
        return props.children
    }

    return null
}

export default Perfil